import B2BClientRequestModal from '@/components/modals/B2BClientRequestModal';
import { ControlPoint } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import ComposedDrawerMenuAppBar from 'components/ComposedDrawerMenuAppBar';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useOutletContext } from 'react-router-dom';
import { ClientSchemaType, findMenuItemByTo, useBreadcrumbSegments } from 'remote/global';
import { ROUTES } from 'utils/data/routes';
import useMenuItems from 'utils/hooks/useMenuItems';

export type ClientRequestContextType = {
  setIsClientEditModalOpen: (
    open: React.Dispatch<React.SetStateAction<boolean>>
  ) => (bool: boolean) => void;
  setSelectedClient: (data: ClientSchemaType) => void;
};

function B2BView() {
  const tInstance = useTranslation();
  const { t } = tInstance;
  const [selectedClient, setSelectedClient] = useState<ClientSchemaType>();
  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);
  const [isClientEditModalOpen, setIsClientEditModalOpen] = useState(false);
  const menuItems = useMenuItems();
  const segments = useBreadcrumbSegments({ menuItems });
  const lastSegment = segments[segments.length - 1];
  const currentMenuItem = findMenuItemByTo(menuItems, lastSegment.path);

  const title: Record<string, string> = {
    [ROUTES.MainRoutes.B2B]: t('B2BView.myclients.title').toString(),
  };

  const currentTitle = currentMenuItem ? title[currentMenuItem.itemKey] : lastSegment.name;

  const handleClearClientRequestModalState = () => {
    setIsAddClientModalOpen(false);
    setSelectedClient(undefined);
  };

  const handleClearClientEditModalState = () => {
    setIsClientEditModalOpen(false);
    setSelectedClient(undefined);
  };

  return (
    <>
      <B2BClientRequestModal
        open={isAddClientModalOpen}
        setOpen={setIsAddClientModalOpen}
        onClose={handleClearClientRequestModalState}
      />

      <B2BClientRequestModal
        defaultValues={selectedClient}
        open={isClientEditModalOpen}
        setOpen={setIsClientEditModalOpen}
        onClose={handleClearClientEditModalState}
      />
      <ComposedDrawerMenuAppBar
        title={currentTitle}
        slot={
          <Button
            size='small'
            variant='text'
            onClick={() => setIsAddClientModalOpen(true)}
            startIcon={<ControlPoint />}
            sx={{
              minWidth: 46,
              py: 0,
              height: 'auto',
              '.MuiButton-startIcon': { mr: { xs: 0, sm: 1 } },
              textDecoration: 'none',
            }}
          >
            <Box component='p' sx={{ display: { xs: 'none', sm: 'unset' }, m: 0 }}>
              {t('actions.user.sendContract')}
            </Box>
          </Button>
        }
      />

      <Box sx={{ p: { xs: 1, md: 2 } }}>
        <Outlet
          context={{
            selectedClient,
            setSelectedClient,
            setIsClientEditModalOpen,
          }}
        />
      </Box>
    </>
  );
}

export default B2BView;
export function useClientRequestModal() {
  return useOutletContext<ClientRequestContextType>();
}
export function useSendOfferModal() {
  return useOutletContext<ClientRequestContextType>();
}
